<template>
  <div class="coursesCard -type-1 pb-10 border-light bg-white rounded-8 mb-3" data-aos="fade-up" :data-aos-delay="200">
    <router-link :to="`/packages/${item?.slug}`">
      <div class="relative">
        <div class="coursesCard__image overflow-hidden rounded-8">
          <div class="course-image-container">
            <img class="w-1/1" :src="item?.cover" alt="image" />
          </div>

          <!--Pricing page------------>
          <div class="d-inline-flex justify-content-center align-items-center x-gap-10 discount">
            <span style="display: none;"></span>
            <span class="capitalize offer"
  v-if="item?.pricing?.original_price - item?.pricing?.price !== 0 && !item?.pricing?.is_free">
  {{ Math.ceil(
    ((item?.pricing?.original_price - item?.pricing?.price) /
      item?.pricing?.original_price) * 100
  ) }}% Off
</span>

            <!-- <span class="capitalize offer"
              v-if="item?.pricing?.original_price - item?.pricing?.price !== 0 && !item?.pricing.is_free">
              {{ ((item?.pricing?.original_price - item?.pricing?.price) /
                item?.pricing?.original_price *
                100).toFixed(2) }} % Off
            </span> -->

            <span class="capitalize" v-if="item?.pricing.is_free">
              {{ $t('free') }}
            </span>
          </div>
          <!-------------->

        </div>
      </div>
    </router-link>

    <div class="px-10 pt-10 d-flex flex-column gap-2 courseCard-body">
      <h3 class="fw-700 text-dark-1 mt-15 capitalize">
        {{ item?.title }}
      </h3>

      <div class="text-align-start">
        <div v-html="item?.description?.length > 100 ? item.description.substring(0, 60) + '...' : item.description">
        </div>
      </div>

      <!---Price Section-->
      <div class="mb-3">
        <div class="d-flex flex-column align-items-start pb-10 pt-2 price">
          <span class="pt-1"
            :class="item?.pricing?.original_price - item?.pricing?.price !== 0 ? 'fw-700 price-orginial d-inline-block ' : 'd-none'">
            {{ item?.pricing?.price }}
            {{ item?.pricing?.currency }}
          </span>

          <span class="pt-1"
            :class="item?.pricing?.original_price - item?.pricing?.price !== 0 ? 'fw-400 d-inline-block exprience line-through text-16' : 'fw-700 price-orginial '">
            {{ item?.pricing?.original_price }}
            {{ item?.pricing?.currency }}
          </span>
        </div>
        <!--- Yealry Pricing start -->
        <!-- <div class="d-flex flex-column align-items-start pb-10  pt-2 price" v-else-if="!monthly">
          <span class="pt-1"
            :class="item?.pricing?.yearly.original_price - item?.pricing.yearly?.price !== 0 ? 'fw-700 price-orginial d-inline-block ' : 'd-none'">
            {{ item?.pricing?.yearly.price }} 
            {{ item?.pricing?.yearly.currency }} / {{$t('year')}}
          </span>

          <span class="pt-1"
            :class="item?.pricing?.yearly.original_price - item?.pricing?.yearly.price !== 0 ? 'fw-400 d-inline-block exprience line-through text-16' : 'fw-700 price-orginial '">
            {{ item?.pricing?.yearly.original_price }}
            {{ item?.pricing?.yearly.currency }}
          </span>
        </div> -->
        <!---End Of Yearly Pricig -->
      </div>
      <!----------------->
    </div>
  </div>
</template>
<script>
import store from '@/store';
import RatingComponent from './RatingComponent.vue';
export default {
  components: { RatingComponent },
  props: {
    showPrice: {
      type: Boolean,
      default: false,
    },
    // monthly: {
    //   type: Boolean,
    //   default: true,
    // },
    showLevel: {
      type: Boolean,
      default: false,
    },
    item: {
      type: Object
    }
  },
  computed: {
    isAuthenticated() {
      return store.getters.isAuthenticated
    }
  }
};
</script>
<style lang="scss">
.description {
  &:lang(en) {
    text-align: left;
  }

  &:lang(ar) {
    text-align: right;
  }
}
</style>